import { Box } from '@factorialco/deprecated-design-system'

import { ModuleRelatedUpdatesCard } from 'modules/product_updates/components/ModuleRelatedUpdatesCard'
import { ProductUpdate } from 'modules/product_updates/types'

type Props = {
  productUpdate?: ProductUpdate
}

const RelatedUpdatesCards = ({ productUpdate }: Props) => {
  return (
    <Box gap="s16" width="full">
      <ModuleRelatedUpdatesCard productUpdate={productUpdate} />
    </Box>
  )
}

export default RelatedUpdatesCards
